export const TABLE_REFUELING_KEY = 'v1/refueling';
export const TABLE_REFUELING_ID = 'id';
export const TABLE_REFUELING_CUSTOMER = 'customer';
export const TABLE_REFUELING_VEHICLE_ID = 'vehicleId';
export const TABLE_REFUELING_VEHICLE_NAME = 'vehicleName';
export const TABLE_REFUELING_VEHICLE_LICENCE_NUMBER = 'licenceNumber';
export const TABLE_REFUELING_LOCKED = 'locked';
export const TABLE_REFUELING_BILL = 'bill';
export const TABLE_REFUELING_GAS_STATION_NETWORK_ID = 'gasStationNetwork';
export const TABLE_REFUELING_ASSIGNED_TO_RIDE = 'assignedToRide';
export const TABLE_REFUELING_FUEL_TYPE = 'fuelType';
export const TABLE_REFUELING_IDENTIFIER = 'identifier';
export const TABLE_REFUELING_ACCOUNTING_TS = 'accountingTs';
export const TABLE_REFUELING_AMOUNT = 'amount';
export const TABLE_REFUELING_FUEL_LEVEL_CAN = 'fuelLevelCan';
export const TABLE_REFUELING_FUEL_LEVEL_USER = 'fuelLevelUser';
export const TABLE_REFUELING_AVERAGE_FUEL_CONS_CAN = 'averageFuelConsCan';
export const TABLE_REFUELING_FUEL_CONS_CAN = 'fuelConsCan';
export const TABLE_REFUELING_PRICE_INC_VAT = 'priceIncVat';
export const TABLE_REFUELING_PRICE = 'price';
export const TABLE_REFUELING_VAT = 'vat';
export const TABLE_REFUELING_VAT_PRICE = 'vatPrice';
export const TABLE_REFUELING_UNIT_PRICE = 'unitPrice';
export const TABLE_REFUELING_UNIT_PRICE_INC_VAT = 'unitPriceIncVat';
export const TABLE_REFUELING_CURRENCY = 'currency';
export const TABLE_REFUELING_ANOTHER_CURRENCY = 'anotherCurrency';
export const TABLE_REFUELING_MILEAGE = 'mileage';
export const TABLE_REFUELING_AVERAGE_CONSUMPTION = 'averageConsumption';
export const TABLE_REFUELING_NOTE = 'note';
export const TABLE_REFUELING_SOURCE = 'source';
export const TABLE_REFUELING_RIDESOURCE = 'rideSource';
export const TABLE_REFUELING_POSITIONCOUNT = 'positionCount';
export const TABLE_REFUELING_CREATED_BY = 'createdBy';
export const TABLE_REFUELING_CREATED_AT = 'createdAt';
export const TABLE_REFUELING_MODIFIED_BY = 'modifiedBy';
export const TABLE_REFUELING_MODIFIED_AT = 'modifiedAt';
export const TABLE_REFUELING_LINKS = 'links';
export const TABLE_REFUELING_ATTACHMENTS = 'attachments';
export const TABLE_REFUELING_THEORETICAL_CONSUMPTION = 'theoreticalConsumption';
export const TABLE_REFUELING_MILE_AGE_DIFF_KM = 'mileageDiffKm';
export const TABLE_REFUELING_SETTINGS_KEY = 'refueling_v2';
